// Utility to get safe API base URL for all API calls
// Handles production deployments where REACT_APP_BACKEND_URL may be undefined or malformed

export const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  // Return empty string (relative URL) if env var is missing, undefined, or "undefined" string
  if (!envUrl || envUrl === 'undefined' || envUrl === 'null') {
    return '';
  }
  
  // Remove trailing slash if present
  return envUrl.replace(/\/$/, '');
};

export const API_BASE_URL = getApiBaseUrl();
